import { getIn } from 'formik'
import styles from './FormikErrors.module.scss'

export const FormikError = ({ formik, fieldName }) => {
  const showError = formik && (formik.submitCount > 0 || getIn(formik.touched, fieldName)) && getIn(formik.errors, fieldName)

  return showError ? (
    <span id={`${fieldName}-error`} className={styles['error']} role='alert'>
      {getIn(formik.errors, fieldName)}
    </span>
  ) : null
}
